export const READ_ALOUD_SETTING = { DEFAULT: 'default', OFF: 'off', ON: 'on', } as const
export type ReadAloudSetting = typeof READ_ALOUD_SETTING[keyof typeof READ_ALOUD_SETTING]

const OVERRIDE_FOR_SETTING: Record<ReadAloudSetting, boolean | null> = { [READ_ALOUD_SETTING.ON]: true, [READ_ALOUD_SETTING.OFF]: false, [READ_ALOUD_SETTING.DEFAULT]: null, }

export const SETTING_LABELS: Record<ReadAloudSetting, string> = { [READ_ALOUD_SETTING.ON]: 'On', [READ_ALOUD_SETTING.OFF]: 'Off', [READ_ALOUD_SETTING.DEFAULT]: 'Follows default setting', }

export const MENU_LABELS: Record<ReadAloudSetting, string> = { ...SETTING_LABELS, [READ_ALOUD_SETTING.DEFAULT]: 'Follow default setting', }

export const MENU_OPTIONS = [READ_ALOUD_SETTING.DEFAULT, READ_ALOUD_SETTING.ON, READ_ALOUD_SETTING.OFF].map(value => ({ label: MENU_LABELS[value], value, }))

export const settingForState = (on: boolean): ReadAloudSetting => on ? READ_ALOUD_SETTING.ON : READ_ALOUD_SETTING.OFF

export const settingFor = (override: boolean | null | undefined): ReadAloudSetting => (
  (Object.keys(OVERRIDE_FOR_SETTING) as ReadAloudSetting[]).find(setting => OVERRIDE_FOR_SETTING[setting] === (override ?? null))
)

export const effectiveReadAloud = (override: boolean | null | undefined, ownerDefault: boolean): boolean => override ?? ownerDefault

export const effectiveReadAloudForSetting = (setting: ReadAloudSetting, ownerDefault: boolean): boolean => effectiveReadAloud(OVERRIDE_FOR_SETTING[setting], ownerDefault)

export const onOrOff = (on: boolean) => on ? 'On' : 'Off'
